import { Component, inject, Input, OnInit } from '@angular/core';
import { PremiumDisplayComponent } from '@shared/components/premium-display/premium-display.component';
import { QuestionBoxComponent } from '@shared/components/question-box/question-box.component';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { defaultAnswerOptions } from '@shared/models/default-answer-options';
import { CalculationErrorDisplayComponent } from '@shared/components/calculation-error-display/calculation-error-display.component';
import { NgClass } from '@angular/common';
import { SkipperFormModel } from '@shared/models/forms/skipper-form.model';
import { SkipperCalculationService } from '../../services/skipper-calculation.service';
import { DataBaseComponent } from '@shared/directives/data-base.component';
import { environment } from '@environment/environment';
import { startWith, switchMap, takeUntil } from 'rxjs';

@Component({
  selector: 'app-skipper-rechtsschutz-details',
  imports: [
    PremiumDisplayComponent,
    QuestionBoxComponent,
    ReactiveFormsModule,
    TranslocoPipe,
    CalculationErrorDisplayComponent,
    NgClass
  ],
  templateUrl: './skipper-rechtsschutz-details.component.html',
  styleUrl: './skipper-rechtsschutz-details.component.scss'
})
export class SkipperRechtsschutzDetailsComponent extends DataBaseComponent implements OnInit {
  @Input() form!: FormGroup<SkipperFormModel>;

  protected readonly skipperCalculationService = inject(SkipperCalculationService);

  showCalculationPremiumEnabled = environment.featureToggles.showCalculationPremiumEnabled;
  protected readonly defaultAnswerOptions = defaultAnswerOptions;

  ngOnInit(): void {
    this.form.valueChanges
      .pipe(
        startWith(this.form.value),
        switchMap(() => this.skipperCalculationService.calculate(this.form)),
        takeUntil(this.componentDestroyed$)
      )
      .subscribe();
  }

  isValid(): boolean {
    if (!this.form.controls.isKundeSkipperVertragsHaftpflichtSelected.value && !this.form.controls.isKundeSkipperVertragsRechtsschutzSelected.value) {
      return false;
    }
    if (this.form.controls.isKundeSkipperVertragsRechtsschutzSelected.value) {
      const ctrls = this.form.controls.skipperRechtsschutz.controls;
      return !!ctrls.isSailAreaExplicitlyInEurope.value &&
        !!ctrls.isBoatExplicitlyUsedPrivately.value &&
        (!ctrls.hasAlreadyHadDamagesOrLegalDispute.value ||
          !!ctrls.hasAlreadyHadDamagesOrLegalDisputeDescription.value);

    }
    if (this.form.controls.isKundeSkipperVertragsHaftpflichtSelected.value) {
      return true;
    }
    throw new Error('this should not happen');
  }
}
